import React, { useState } from "react";
import { Caption, Title } from "../../router";
import { commonClassNameOfInput } from "../../components/common/Design";
import axios from "axios";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

// Generate dedupe key for manual alerts
const generateDedupeKey = () => {
  return `MANUAL|${Date.now()}|${Math.random().toString(36).substr(2, 6)}`;
};

export const AddProduct = () => {
  const [content, setContent] = useState("");
  const [submitting, setSubmitting] = useState(false);

  const onChange = (e) => {
    setContent(e.target.value);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (submitting) return;

    if (content.trim() === "") {
      toast.error("Alert content cannot be empty", { theme: "colored" });
      return;
    }

    setSubmitting(true);
    toast.info("Sending alert…", { theme: "colored" });

    const requestBody = {
      content,
      dedupe_key: generateDedupeKey()
    };

    const headers = {
      headers: {
        authorization: `Bearer ${localStorage.getItem("token")}`
      }
    };

    try {
      await axios.post(
        `${process.env.REACT_APP_API_URL}add-alert-content`,
        requestBody,
        headers
      );

      toast.success("Alert sent successfully", { theme: "colored" });
      setContent("");
    } catch (error) {
      console.error(error);

      if (error.response) {
        const status = error.response.status;
        const message =
          error.response.data?.status ||
          error.response.data?.error ||
          "Request failed";

        if (status === 400) {
          toast.error(message, { theme: "colored" });
        } else if (status === 401 || status === 403) {
          toast.error("You are not authorized to perform this action", {
            theme: "colored"
          });
        } else if (status >= 500) {
          toast.error(
            "A server error occurred. Please try again shortly.",
            { theme: "colored" }
          );
        } else {
          toast.error(message, { theme: "colored" });
        }
      } else if (error.request) {
        toast.error(
          "Unable to reach the server. Please check your internet connection.",
          { theme: "colored" }
        );
      } else {
        toast.error("An unexpected error occurred.", { theme: "colored" });
      }
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <>
      <section className="p-8 bg-white shadow-s1 rounded-xl">
        <Title level={5} className="mb-5 font-normal">
          Add Alert Content
        </Title>

        <hr className="my-5" />

        <form onSubmit={handleSubmit}>
          <div>
            <Caption className="mb-2">Content</Caption>
            <textarea
              name="content"
              className={commonClassNameOfInput}
              cols="30"
              rows="5"
              value={content}
              onChange={onChange}
              required
              disabled={submitting}
            />
          </div>

          <button
            type="submit"
            disabled={submitting}
            className={`w-full px-16 py-3 my-5 text-lg font-medium text-white transition ease-in-out rounded-full
              ${submitting ? "bg-gray-400 cursor-not-allowed" : "bg-green hover:bg-primary"}`}
          >
            {submitting ? "SENDING…" : "SEND ALERT"}
          </button>
        </form>
      </section>

      <ToastContainer />
    </>
  );
};
